import type { Components, Theme } from '@mui/material';
import { buttonConfig } from './button';
import { containerConfig } from './container';
import { dividerConfig } from './divider';
import { gridConfig } from './grid';
import { typographyConfig } from './typography';

export const components: Components<Omit<Theme, 'components'>> = {
  ...typographyConfig,
  ...gridConfig,
  ...buttonConfig,
  ...dividerConfig,
  ...containerConfig,
};
